import PropTypes from "prop-types";
import styles from "./GamanzaWidgetSlot.module.css";

/**
 * Shared Gamanza mount point: keeps .gamification_widget in the DOM while a
 * skeleton covers it until Engage hydrates (same pattern for drawer, pages, avatars).
 */
const GamanzaWidgetSlot = ({
  dataType,
  id,
  className = "",
  isHydrating = false,
  variant = "block",
  minHeight,
  size,
  dataAttrs = {},
  style,
}) => {
  const isCircle = variant === "circle";
  const slotStyle = {
    ...(style || {}),
    ...(minHeight ? {minHeight} : {}),
    ...(size ? {"--gamanza-slot-size": typeof size === "number" ? `${size}px` : size} : {}),
  };

  return (
    <div
      className={`${styles.slot} ${isCircle ? styles.slotCircle : ""}`}
      style={slotStyle}
      aria-busy={isHydrating}
    >
      {isHydrating && (
        <span
          className={`${styles.skeleton} ${isCircle ? styles.skeletonCircle : styles.skeletonBlock}`}
        />
      )}
      <div
        id={id}
        className={`gamification_widget ${className} ${isHydrating ? styles.pending : styles.ready}`}
        data-type={dataType}
        {...dataAttrs}
      />
    </div>
  );
};

GamanzaWidgetSlot.propTypes = {
  dataType: PropTypes.string.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  isHydrating: PropTypes.bool,
  variant: PropTypes.oneOf(["block", "circle"]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dataAttrs: PropTypes.object,
  style: PropTypes.object,
};

export default GamanzaWidgetSlot;
